import React from 'react';

const ButtonLightBlueInverted = ({type,onSubmit,onClick,disabled,text}) => {

  return (
    <button 
        type={type || 'submit'} 
        className='font-semibold text-center block bg-custom-charcoal text-custom-light-blue rounded-md w-full min-h-[45px] hover:bg-custom-light-blue hover:text-white transition-colors duration-200 px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed'
        disabled={disabled ? true : false}
        onSubmit={onSubmit || null}
        onClick={onClick || null}
    >
        {text}
    </button>
  );
};

export default ButtonLightBlueInverted;
